/* eslint-disable no-nested-ternary */ /* eslint-disable camelcase */ /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable react/prop-types */ import React from 'react';import { withStyles, makeStyles } from '@material-ui/core/styles';
// import moment from 'moment-timezone';
import {
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
} from '@material-ui/core';
import moment from 'moment';

import GetApp from '@material-ui/icons/GetApp';
import { formatCurrency } from '../../../../service/utils';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
  table: {
    minWidth: 1100,
  },
});

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: '#303474',
    color: 'white',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line import/prefer-default-export
export function LowTable({
  docs,
  total,
  page,
  setPage,
  itens,
  setItens,
  getXls,
}) {
  const classes = useStyles();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setItens(parseInt(event.target.value, 10));
    setPage(0);
  };

  const returnCat = cat => {
    switch (cat.toUpperCase()) {
      case 'REEMBOLSO DE DESPESAS COM AUMENTO DE PRODUTIVIDADE':
        return 'PRÊMIO';
      case 'REEMBOLSO CAMPANHA DE MARKETING E PROMOÇÃO':
        return 'PRÊMIO';
      case 'REEMBOLSO CAMPANHA DE MARKETING E INCENTIVO':
        return 'PRÊMIO';
      default:
        return cat.toUpperCase();
    }
  };

  return (
    <Paper className={classes.root}>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nota Fiscal</StyledTableCell>
              <StyledTableCell>N do Pedido</StyledTableCell>
              <StyledTableCell>CNPJ NF Element</StyledTableCell>
              <StyledTableCell>Emissão</StyledTableCell>
              <StyledTableCell>Vencimento</StyledTableCell>
              <StyledTableCell>Recebimento</StyledTableCell>
              <StyledTableCell>Conciliação</StyledTableCell>
              <StyledTableCell>Banco</StyledTableCell>
              <StyledTableCell>Valor</StyledTableCell>
              <StyledTableCell>Receita</StyledTableCell>
              <StyledTableCell>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  Cliente
                  <GetApp onClick={getXls} style={{ cursor: 'pointer' }} />
                </div>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {docs?.map((row, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <StyledTableRow key={index}>
                <StyledTableCell>
                  {row?.invoice_number || row?.debit_note_number}
                </StyledTableCell>
                <StyledTableCell>
                  {row?.debit_note_number
                    ? row?.order_number
                    : row?.type === 'Card'
                    ? 'CARTÃO'
                    : 'CC'}
                </StyledTableCell>
                <StyledTableCell>{row?.cnpj}</StyledTableCell>
                <StyledTableCell>
                  {row?.created_at &&
                    moment(row?.created_at).format('DD/MM/YYYY')}
                </StyledTableCell>
                <StyledTableCell>
                  {row?.dataConciliation &&
                    moment(row?.dataConciliation)
                      .endOf('month')
                      .format('DD/MM/YYYY')}
                </StyledTableCell>
                <StyledTableCell>
                  {row?.date_payment &&
                    moment(row?.date_payment).format('DD/MM/YYYY')}
                </StyledTableCell>
                <StyledTableCell>
                  {row?.dataConciliation &&
                    moment(row?.dataConciliation).format('DD/MM/YYYY')}
                </StyledTableCell>
                <StyledTableCell>{row?.bank}</StyledTableCell>
                <StyledTableCell>
                  {' '}
                  {formatCurrency(row?.singleCategory?.valor).replace(',', '.')}
                </StyledTableCell>
                <StyledTableCell>
                  {returnCat(row?.singleCategory?.categoria)}
                </StyledTableCell>
                <StyledTableCell>{row?.client}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={total || 0}
        rowsPerPage={itens}
        page={page}
        labelRowsPerPage="Linhas por página:"
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
